module.exports = __webpack_public_path__ + "static/media/biteprod.16962804.PNG";